import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  constructor() {}

   	ngOnInit() {
    }

}




// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/header/header.component.ts